module.exports = __webpack_public_path__ + "img/google-forms.10a9cf91.png";